export default __webpack_public_path__ + "static/media/snowuns-book.ecbeae3e.webp";